import AbstractRequestTask from '../AbstractRequestTask';
import Launcher from '../../apa/Launcher';

class PayWayProfileTask extends AbstractRequestTask {
    constructor(params) {
        super();
        this.params = params;
    }

    getMethod() {
        return 'GET';
    }

    getHeaders() {
        const params = super.getParams();
        return {
            'Authorization': 'Bearer ' + params.user_token
        };
    }

    getParams() {
        const params = super.getParams();
        return {
          authpn: params.authpn,
          authpt: params.authpt,
      };
    }

    getUrl() {
        const http = 'https://';
        const url = Launcher.get('akamai_mfwk');
        return `${http}${url}/services/payway/paymentservice/v1/profile`;
    }

    success(data, b) {
        this.resolve(data);
    }
}

export default PayWayProfileTask;



// WEBPACK FOOTER //
// ./src/requests/tasks/payway/PayWayProfileTask.js